// LocalStorageService.js
const LocalStorageService = (function () {
  var service
  function _getService() {
    if (!service) {
      service = this
      return service
    }
    return service
  }
  function _setToken(tokenObj) {
    let user = JSON.parse(localStorage.getItem('user'))
    user.token = tokenObj.access_token
    user.refresh_token = tokenObj.refresh_token
    user.expires_in = Date.now() + tokenObj.expires_in
    console.log('SET TOKEN', user)
    localStorage.setItem('user', JSON.stringify(user))
  }
  function _getAccessToken() {
    let user = JSON.parse(localStorage.getItem('user'))
    return user.token
  }
  function _getRefreshToken() {
    let user = JSON.parse(localStorage.getItem('user'))
    return user.refresh_token
  }
  function _clearToken() {
    localStorage.removeItem('user_token')
    localStorage.removeItem('refreshToken')
  }
  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
  }
})()
export default LocalStorageService
